<template>
    <span :class="['rounded-full shrink-0', sizeClass, colorClass]" aria-hidden="true" />
</template>

<script setup lang="ts">
import { type Dimension, DIMENSION_COLORS } from "~vue/pages/perspectiveTypes";
import { computed } from "vue";

type Size = "sm" | "md" | "lg" | "xl";

type Props = {
    dimension: Dimension;
    size?: Size;
};

const { dimension, size = "md" } = defineProps<Props>();

const SIZE_CLASS: Record<Size, string> = {
    sm: "size-2",
    md: "size-2.5",
    lg: "size-3",
    xl: "size-5",
};

const sizeClass = computed(() => SIZE_CLASS[size]);
const colorClass = computed(() => DIMENSION_COLORS[dimension]);
</script>
